import { useInfiniteQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { FILTER_DEFAULT_TAKE } from '@apps-common/config/filter'
import { axios, queryClient } from '@apps-common/lib'
import { IUnitTriggerQueueBasicModel } from '@apps-common/types/portal/unit-trigger'

export const QUERY_KEY_MY_MONITORING_GET_UNIT_TRIGGER_HISTORY_BY_TRIGGER = (triggerId?: number, take?: number) =>
  ['getMyMonitoringUnitTriggerHistoryByTrigger', triggerId, take].filter(Boolean)

const getUnitTriggerHistoryByTrigger = async (triggerId?: number, skip?: number, take?: number): Promise<IUnitTriggerQueueBasicModel[]> =>
  axios
    .get(`/my-monitoring/sites/GetTriggerHistoryByTrigger?triggerId=${triggerId}&skip=${skip}&take=${take}`)
    .then((res) => res.data?.data)

type Props = {
  triggerId?: number
  take?: number
  enabled?: boolean
}

export const useMyMonitoringGetUnitTriggerHistoryByTrigger = ({ triggerId, take = FILTER_DEFAULT_TAKE, enabled }: Props) => {
  const { isLoading, isFetching, isRefetching, isError, data, refetch, fetchNextPage, hasNextPage } = useInfiniteQuery({
    queryKey: QUERY_KEY_MY_MONITORING_GET_UNIT_TRIGGER_HISTORY_BY_TRIGGER(triggerId, take),
    initialPageParam: 0,
    enabled,
    queryFn: ({ pageParam = 0 }) => getUnitTriggerHistoryByTrigger(triggerId, pageParam, take),
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage?.length < take) {
        return null
      }

      return allPages?.reduce((acc, curr) => acc + (curr?.length || 0), 0)
    }
  })

  useEffect(
    () => () => {
      queryClient.removeQueries({ queryKey: QUERY_KEY_MY_MONITORING_GET_UNIT_TRIGGER_HISTORY_BY_TRIGGER() })
    },
    []
  )

  return { isLoading, isFetching, isRefetching, isError, data, refetch, fetchNextPage, hasNextPage }
}
